var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSRankCommBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-rank-comm",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ph-chats-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.923c-0.001,-0.849 -0.689,-1.537 -1.538,-1.538l-3.077,-0l-0,-3.077c-0.001,-0.849 -0.69,-1.538 -1.539,-1.539l-12.308,0c-0.849,0.001 -1.537,0.69 -1.538,1.539l-0,12.307c-0,0.425 0.344,0.77 0.769,0.77c0.184,-0 0.353,-0.065 0.485,-0.172l-0.001,0.001l3.362,-2.719l0,2.89c0.001,0.849 0.69,1.537 1.539,1.538l8.999,0l3.594,2.906c0.131,0.106 0.3,0.171 0.484,0.171c0.425,-0 0.769,-0.344 0.769,-0.769l-0,-0l-0,-12.308Zm-4.092,8.633c-0.131,-0.107 -0.299,-0.171 -0.483,-0.171l-9.271,-0l-0,-3.077l7.692,-0c0.849,-0.001 1.538,-0.689 1.539,-1.539l-0,-3.846l3.077,0l-0,10.697l-2.554,-2.064Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSRankCommBlack);
export default __webpack_public_path__ + "static/media/iconS-rank-comm-black.19e580cfcdf32c8077d766205ec13d25.svg";
export { ForwardRef as ReactComponent };